// v-rule: a hairline (.ck-rule) draws in from the left the first time it scrolls into view.
const observer = typeof IntersectionObserver !== 'undefined'
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-in');
                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0.2 })
    : null;

export const rule = {
    mounted(el) {
        el.classList.add('ck-rule');
        if (observer) observer.observe(el);
        else el.classList.add('is-in');
    },
    unmounted(el) {
        if (observer) observer.unobserve(el);
    }
};
